import { Box, Button, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { modalStyle } from "../../../../../../../components/modalStyle";
import { useDocTransmittalContext } from "../DocTransmittal.context";
import EditableTable from "../../../../../../../components/Tables/EditableTable";
import { docTransmittalRegisterColumns } from "./docTransmittalRegisterColumns";
import { useParams } from "react-router-dom";
import {
  addNewDocTransmittalRegister,
  getAllDocTransmittalsProject,
} from "../api";
import moment from "moment";
import { useAuthContext } from "../../../../../../../context/authContext";

export default function DocTransmittalRegister() {
  const { user } = useAuthContext();
  const {
    openDocTransmittalRegister,
    handleCloseDocTransmittalRegister,
    vendors,
    clients,
  } = useDocTransmittalContext();

  const [docTransmittalRegister, setDocTransmittalRegister] = useState([]);
  const { plantId } = useParams();

  const fetchData = async () => {
    const res = await getAllDocTransmittalsProject({ plantId });
    if (res) {
      setDocTransmittalRegister(res || []);
    }
  };
  console.log("docTransmittalRegister", docTransmittalRegister);
  const currentSerial = docTransmittalRegister.length + 1;

  const api = {
    getItems: async (parentId) => {
      const res = await getAllDocTransmittalsProject({ plantId: parentId });
      return res || [];
    },
    createItem: async (parentId, item) => {
      console.log("item", { ...item, user, plantId });

      await addNewDocTransmittalRegister({
        ...item,
        user,
        plantId,
        serial: currentSerial,
      });

      await fetchData();
    },
    updateItem: async (item) => {
      console.log("Update not implemented", item);
    },
    deleteItem: async (id) => {
      console.log("Delete not implemented", id);
    },
  };

  useEffect(() => {
    fetchData();
  }, []);

  const initialData = {
    number: "Doc-transmittal-" + currentSerial,
    serial: currentSerial,
    rev: 0,
    receiver: { id: "", name: "", email: "" },
    receiverType: "",
    initiatedBy: user?.name || "",
    date: moment(new Date().toLocaleDateString()).format("YYYY-MM-DD"),
  };

  return (
    <Modal
      open={openDocTransmittalRegister}
      onClose={handleCloseDocTransmittalRegister}
    >
      <Box
        sx={{
          ...modalStyle,
          width: 1100,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
          Document Transmittal Register
        </Typography>

        <EditableTable
          name="Document Transmittal"
          columns={docTransmittalRegisterColumns(vendors, clients)}
          displayMode="modal"
          api={api}
          enableEditing={true}
          enableCreate={true}
          initialData={initialData}
          parentId={plantId}
        />

        <Box sx={{ textAlign: "right", mt: 2 }}>
          <Button
            sx={{ mx: 1 }}
            variant="outlined"
            onClick={handleCloseDocTransmittalRegister}
            color="error"
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
